$shm_dashboard_opencode_app $shm_opencode_app
	sessions_title \М+ Агент
	dashboard null $shm_ba_dashboard_model
	dashboard_id \
	dashboard_title \
	Message_text* $shm_ba_agent_message_text
		text <= message_text*
